<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <yz-daterange @dateRange="getChooseTime"></yz-daterange>
        <el-input v-model.trim="inputVal" class="input_s200" placeholder="请输入姓名/会员卡号" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="commonInfo">
        <div class="content">
          <h3>时间：{{ value?value[0]:'' }}~{{ value?value[1]:'' }}</h3>
          <h3>收入总额：{{ sumTotal ? sumTotal.toFixed(2) : '0.00' }}元</h3>
        </div>
      </div>
      <div class="commonTable">
        <el-table :data="tableData" tooltip-effect="light">
          <el-table-column prop="createTimeSte" :show-overflow-tooltip="true" label="时间">
          </el-table-column>
          <el-table-column prop="memberName" :show-overflow-tooltip="true" label="姓名">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="会员卡号">
            <template slot-scope="scope">
              <span>{{ scope.row.cardNo || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="serviceName" :show-overflow-tooltip="true" label="赠送项目">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="价值（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.price ? scope.row.price : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="有效期" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.validDateStr || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <gt-footer></gt-footer>
  </div>
</template>

<script>
import { getZs } from '../../api';

export default {
  data() {
    return {
      value: '', // 时间段
      inputVal: '', // 搜索值
      currentPage: 1,
      tableData: [], // 赠送记录列表
      pageNum: 1,
      rowCount: '',
      sumTotal: '', // 收入总额
    };
  },
  activated() {
    this.getListData();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTime(time) {
      this.value = time;
      this.chooseTime(time);
    },
    // 选择时间段
    chooseTime() {
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 导出列表
    exportList() {
      const vm = this;
      if (vm.value) {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportServiceFee?startDate=${
          vm.value[0]
        }&endDate=${
          vm.value[1]
        }&keyWord=${
          vm.inputVal}`;
      } else {
        window.location.href = `${this.Lib.A()
        }/erp/statistics/exportServiceFee?keyWord=${
          vm.inputVal}`;
      }
    },
    // 赠送记录列表
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getZs(data).then((res) => {
        vm.tableData = res.data.page.subList;
        vm.sumTotal = res.data.sumTotal;
        vm.rowCount = res.data.page.rowCount;
      });
    }
  }
};
</script>
